import { Skeleton, SkeletonProps } from '@mui/material';

import skeletonTheme from './Skeleton';

export default Skeleton;
export { skeletonTheme };
export type { SkeletonProps };
